import React from 'react';
import ReposTableComponent from '#app/pages/Investing/Invests/components/Current/ReposTable';
import { RepoData } from '#app/pages/Relations/Repos/types/repoTypes';
import { ReposTableType } from '#app/pages/Investing/Invests/components/Current/ReposTable';
import { Title3 } from '#app/components/Text/styles';
import { InvestTitle } from 'src/pages/styles';

// Типизация для компонента, обернутого в connect
const ReposTable = ReposTableComponent as any;

interface ReposSectionProps {
  repos: RepoData[];
  /** Имя брокера/счёта — как GROUP_HEADER в виртуальном списке активов (Title3 + InvestTitle). */
  brokerTitle?: string | null;
  /** Уникальный id для таблицы при нескольких блоках РЕПО на странице. */
  tableDomId?: string;
  tableType?: ReposTableType; // Тип таблицы: 1 - открытые, 2 - закрытые
  currency?: {
    id: string;
    code?: string;
    sign?: string;
  } | null;
  requestClientId?: string | number;
  stickyHeader?: boolean;
  i18n?: {
    invest?: {
      repo?: string;
    };
    common?: {
      quantity?: string;
    };
  };
}

export default function ReposSection({
  repos,
  brokerTitle,
  tableDomId = 'repo',
  tableType = ReposTableType.OPENED,
  currency,
  requestClientId,
  stickyHeader,
  i18n: _i18n,
}: ReposSectionProps) {
  if (!repos || repos.length === 0) return null;

  return (
    <>
      {brokerTitle ? (
        <div style={{ marginTop: 8 }}>
          <InvestTitle>
            <Title3>{brokerTitle}</Title3>
          </InvestTitle>
        </div>
      ) : null}
      <ReposTable
        items={repos}
        currency={currency}
        id={tableDomId}
        tableType={tableType}
        requestClientId={requestClientId}
        stickyHeader={stickyHeader}
      />
    </>
  );
}
